import React, { useState, useEffect } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router'
import './Assessment.css'
import { Button, Card, Col, Row, notification } from 'antd'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import QuizIcon from '@mui/icons-material/Quiz';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import axios from 'axios';
import { AssesmentUrl,BaseUrl, getImageQuestion, getManualQuestion } from '../../Constants/Constants';
import { useStateValue } from '../../../Reducer/reducer';
import { actionTypes } from '../../../Reducer/StateProvider';

const Assessment = () => {

    const [api, contextHolder] = notification.useNotification();

    const openNotificationWithIconError = (type) => {
        api['error']({
          message: "Oops!!!",
          description:
            type,
        });
      };

    const [courseName, setCourseName] = useState("");
    const [mcqid, setmcqId]= useState("");
    const [
        { UserID },
        dispatch
    ] = useStateValue();
    const { id, assessmentId } = useParams();

    const profileDetails  = JSON.parse(localStorage.getItem('Profile'));

    console.log(profileDetails,'profileDetails')

    const userId = profileDetails.user_id;


    console.log(id, )
    const navigate = useNavigate();
    const [Data, setData] = useState('')
    const [Loading, setLoading] = useState(false)
    const [Questions, setQuestions] = useState({})
    let url = window.location.href;
  let splittedUrl = url.split('/')[6];
  const stringWithSpace = splittedUrl.replace(/-/g, ' ');

  console.log(Data, 'splittedUrl')

    const course = [
        {
            id: "720399f5-8b92-4ca7-8b1f-4dd5410b049b",
            name: "Radiology Partner Course",
        },
        {
            id: "0002",
            name: "Medical Terminology and Anatomy",
        },
        {
            id: "0003",
            name: "Nursing Fundamentals",
        },
        {
            id: "0004",
            name: "Healthcare Informatics",
        },
        {
            id: "0005",
            name: "Epidemiology and Public Health",
        },
        {
            id: "0006",
            name: "Health Policy and Administration",
        },
        {
            id: "0007",
            name: "Patient Care Technician Training",
        },
        {
            id: "0008",
            name: "Inroduction to radiology",
        },
        {
            id: "0009",
            name: "Fundamentals of radiology",
        },
        {
            id: "0010",
            name: "Human Anatomy",
        },
    ];

    // useEffect(() => {
    //     const foundItem = course.find(item => item.id === id);
    //     if (foundItem) {
    //         setCourseName(foundItem.name)
    //     } else {
    //         setCourseName("Course not available!")
    //     }
    // }, [])

    useEffect(() => {

        let body = {
            courseId: id
        }

        axios.post(`${BaseUrl}courses/findOne`, body, { withCredentials: true })

        .then((res) => {

            let response = res.data;

            if (response.statuscode === 200) {
                console.log(res.data.data[0], 'courseDetails');
                setCourseName(response.data[0].course_title);
            }
            else {
                setCourseName('');
            }
        })
        .catch((err) => {
            console.log(err.message)
        })
    }, [])

    useEffect(() => {
        let body = {
            assessment_id : assessmentId
        }
        axios
            .post(`${BaseUrl}assesment/Assesment_details`,body, { withCredentials: true })
            .then((res) => {
                setData(res.data.data)
                console.log(res.data.data ,"Assesment_details")
            })
            .catch((err) => {

            })
            .finally((res) => {

            })
    }, [])


   

    const handleTest = () => {
console.log(Data?.assessment_type_id,"assessment Type")
        if( Data?.assessment_type_id === 1 ) {
        setLoading(true)
        const cleanedString = courseName.replace(/\s+/g, ' ');  
        let modUrl = cleanedString.toLowerCase().split(' ');
        let url = modUrl.join('-');
        let structuredUrl = url.split('/').join('-');
        let Reqbody = {
            course_id: id,
            user_id: userId,
            assessment_id : assessmentId
        }
        console.log('hitnbkajsdf',Reqbody)
        axios
            .post(`${AssesmentUrl}get_questions`, Reqbody)
            .then((res) => {
                console.log(res.data, "mcqgenequestions")
                setQuestions(res.data.generated_mcq)
                setLoading(false)
                dispatch({
                    type: actionTypes.SET_Questions,
                    Questions: res.data.generated_mcq
                  })
                //   const questionIds = res.data.questions.map(question => question.question_id);

                //   console.log(questionIds,"quest")
                navigate(`/courses/${id}/assessment/${assessmentId}/mcq`)
            })
            .catch((err) => {
                console.log(err, 'getQuestionErr');
                openNotificationWithIconError('Error Getting Questions!');
                setLoading(false);
            })
        } else if( Data?.assessment_type_id === 2 ) {

            let body = {
                course_id : id,
                user_id : userId,
                assessment_id : assessmentId,
                no_of_questions : ""
            }

            axios.post(`${AssesmentUrl}get_image_questions`, body )
            .then(( res ) => {
                console.log(res, 'getImageQuestions');
                setLoading(false)
                dispatch({
                    type: actionTypes.SET_Questions,
                    Questions: res.data
                  })
                //   const questionIds = res.data.questions.map(question => question.question_id);

                //   console.log(questionIds,"quest")
                navigate(`/courses/${id}/assessment/${assessmentId}/image`)
            })
            .catch(( err ) => {
                console.log(err, 'get_imgage_questionsError');
                openNotificationWithIconError('Error Getting Questions!');
                setLoading(false);
            })
        }
        else if( Data?.assessment_type_id === 3 ){
            let body = {
                course_id: id,
                assessment_id: assessmentId,
                user_id : userId,
                no_of_questions : Number(Data?.Number_of_questions) || 0,
            }
            axios.post(`${AssesmentUrl}manual_get_question`, body )
            .then(( res ) => {
                console.log(res, 'getImageQuestions');
                if( res.data.status === 200 ){

                    setLoading(false)
                    dispatch({
                        type: actionTypes.SET_Questions,
                        Questions: res.data.gen_questions
                      })
                    navigate(`/courses/${id}/assessment/${assessmentId}/manual`);
                }
                 else{
                    openNotificationWithIconError('Error Getting Questions!');
                 }
            })
            .catch(( err ) => {
                console.log(err, 'get_manual_questionsError');
                openNotificationWithIconError('Error Getting Questions!');
                setLoading(false);
            })
        }
        else if( Data?.assessment_type_id === 4  ) {
            setLoading(true)
            const cleanedString = courseName.replace(/\s+/g, ' ');  
            let modUrl = cleanedString.toLowerCase().split(' ');
            let url = modUrl.join('-');
            let structuredUrl = url.split('/').join('-');
            let Reqbody = {
                course_id: id,
                user_id: userId,
                assessment_id : assessmentId
            }
            console.log('hitnbkajsdf',Reqbody)
            axios
                .post(`${AssesmentUrl}get_questions`, Reqbody)
                .then((res) => {
                    console.log(res.data, "mcqgenequestions")
                    setQuestions(res.data.generated_mcq)
                    setLoading(false)
                    dispatch({
                        type: actionTypes.SET_Questions,
                        Questions: res.data.generated_mcq
                      })
                    //   const questionIds = res.data.questions.map(question => question.question_id);
    
                    //   console.log(questionIds,"quest")
                    navigate(`/courses/${id}/assessment/${assessmentId}/mcqwithdesc`)
                })
                .catch((err) => {
                    console.log(err, 'getQuestionErr');
                    openNotificationWithIconError('Error Getting Questions!');
                    setLoading(false);
                })
            }
    }

    return (
        <div className='assessmentMainDiv'>
            {contextHolder}
            
            {/* Breadcrumb Navigation */}
            <div className='assessmentBreadcrumb'>
                <span className='breadcrumbLink' onClick={(e) => navigate(`/courses`)}>
                    Courses
                </span>
                <ArrowForwardIosIcon className='breadcrumbArrow' />
                {courseName && (
                    <>
                        <span className='breadcrumbLink' onClick={(e) => navigate(`/courses/${id}`)}>
                            {courseName}
                        </span>
                        <ArrowForwardIosIcon className='breadcrumbArrow' />
                    </>
                )}
                <span className='breadcrumbCurrent'>
                    {Data?.Assessment_name || 'Assessment'}
                </span>
            </div>

            {/* Main Content Container */}
            <div className='assessmentContainer'>
                {/* Left Side - Assessment Info */}
                <div className='assessmentInfoSection'>
                    <div className='assessmentHeader'>
                        <div className='assessmentIconWrapper'>
                            <AutoAwesomeIcon className='assessmentIcon' />
                        </div>
                        <h1 className='assessmentTitle'>{Data?.Assessment_name || 'Assessment'}</h1>
                        <p className='assessmentSubtitle'>Ready to test your knowledge? Let's begin your assessment journey.</p>
                    </div>

                    <Card className='assessmentDetailsCard'>
                        <div className='assessmentDetailItem'>
                            <div className='detailIconWrapper'>
                                <EditNoteOutlinedIcon className='detailIcon' />
                            </div>
                            <div className='detailContent'>
                                <span className='detailLabel'>Assessment Type</span>
                                <span className='detailValue'>{Data?.assessment_type?.toUpperCase() || 'N/A'}</span>
                            </div>
                        </div>

                        <div className='assessmentDetailItem'>
                            <div className='detailIconWrapper timeIcon'>
                                <AccessTimeIcon className='detailIcon' />
                            </div>
                            <div className='detailContent'>
                                <span className='detailLabel'>Duration</span>
                                <span className='detailValue'>{Data?.Assesment_Duration || 'N/A'} minutes</span>
                            </div>
                        </div>

                        <div className='assessmentDetailItem'>
                            <div className='detailIconWrapper questionIcon'>
                                <QuizIcon className='detailIcon' />
                            </div>
                            <div className='detailContent'>
                                <span className='detailLabel'>Total Questions</span>
                                <span className='detailValue'>{Data?.Number_of_questions || 'N/A'} questions</span>
                            </div>
                        </div>

                        {Data && Data.assessment_type === "mcq with description" && (
                            <div className='assessmentNote'>
                                <AutoAwesomeIcon className='noteIcon' />
                                <p>Your score will be based on the answer along with the description provided</p>
                            </div>
                        )}
                    </Card>
                </div>

                {/* Right Side - Visual & Action */}
                <div className='assessmentActionSection'>
                    <div className='assessmentVisualWrapper'>
                        <div className='gradientOrb orb1'></div>
                        <div className='gradientOrb orb2'></div>
                        <div className='gradientOrb orb3'></div>
                        <div className='assessmentImageContainer'>
                            <img src='/icons/exam.png' alt='Assessment' className='assessmentImage' />
                        </div>
                    </div>
                    
                    <Button 
                        loading={Loading} 
                        disabled={Loading} 
                        onClick={handleTest} 
                        className='startTestButton'
                        icon={<PlayArrowIcon />}
                        size='large'
                    >
                        {Loading ? 'Preparing Assessment...' : 'Start Assessment'}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Assessment